import app from "../views/app.html";

function urlsConfig($stateProvider, $urlRouterProvider, $locationProvider) {
  "ngInject";

  $locationProvider.html5Mode(true);
  $urlRouterProvider.otherwise("lost");

  $stateProvider.state("app", {
    url: "/",
    abstract: true,
    template: app,
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/core/urls.js